<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.technician-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select
                  name="technicienId"
                  class="ir-form-set"
                  formControlName="technicienId"
                  (change)="initTechnicien()"
                >
                  <option *ngFor="let person of people" [value]="person.id" [selected]="technicienId == person.id">
                    {{ person.name }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
          <tr *ngIf="technicien">
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.technician-telephone' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <h2>
                <span>{{ technicien.phone }}</span>
              </h2>
            </td>
          </tr>
          <tr *ngIf="technicien">
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.technician-email' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <h2>
                <span>{{ technicien.email }}</span>
              </h2>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.service-manager-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  name="regionalServiceManagerName"
                  class="ir-form-set"
                  type="text"
                  formControlName="regionalServiceManagerName"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.service-manager-telephone' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  name="regionalServiceManagerTel"
                  placeholder="+41 21 123 45 67"
                  class="ir-form-set"
                  type="tel"
                  formControlName="regionalServiceManagerTel"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.bobst-contact.service-manager-email' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  name="regionalServiceManagerEmail"
                  class="ir-form-set"
                  type="text"
                  formControlName="regionalServiceManagerEmail"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.bobst-contact.bobst-local-telephone' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <input
                  name="localOfficeTel"
                  placeholder="+41 21 123 45 67"
                  class="ir-form-set"
                  type="tel"
                  formControlName="localOfficeTel"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectTypesMenu($event)" (modalClosed)="onTypesMenuClose()" #typesModal></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
